<template>
  <v-app>
    <v-container fluid>

      <v-card
          v-if="imageSrc"
          class="mx-auto" flat align="center" justify="center">
        <v-card-text>
          <v-row class="fill-height"
                 justify="center"
                 align="center">
            <v-img :src="imageSrc" alt="Your Membership Card"
                   aspect-ratio="1.333"
                   max-width="800"
                   max-height="600"
                   contain/>
          </v-row>
          <v-row class="d-flex justify-center " v-if="imageSrc">
            <v-btn color="primary"
                   @click="downloadCard">Download Card
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row v-else align="center" justify="center">
        <v-card class="mx-auto mt-sm-10" width="500">
          <v-card-title class="flex-column justify-center">
            <v-card-subtitle>
              Enter your South African ID Number to proceed.
            </v-card-subtitle>
            <v-card-text class="mt-5">
              <v-alert border="left"
                       dense
                       text
                       type="error"
                       v-if="message">
                {{ message }}
              </v-alert>

              <v-form @submit.prevent="submit"
                      id="id-form"
                      ref="idForm"
                      v-model="isValid">
                <v-text-field
                    :disabled="isLoading"
                    :rules="[v => !!v || 'Id Number is required']"
                    autocomplete="new"
                    label="ID Number"
                    prepend-icon="mdi-card-account-details"
                    v-model="idNumber"
                />
              </v-form>
              <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading"
                       @click.prevent="submit"
                       class="text-none"
                       color="primary"
                       form="login-form"
                       type="submit">
                  Request Membership Card
                </v-btn>
                <v-spacer/>
              </v-card-actions>
              <v-row align="center"
                     justify="center">
                <v-col>
                  <v-alert
                      dense
                      text
                      type="info"
                      v-if="statusText">
                    {{ statusText }}
                  </v-alert>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card-title>
        </v-card>
      </v-row>

    </v-container>
  </v-app>

</template>

<script>
import axios from 'axios';
import customerService from "../services/customer.service";

export default {
  name: "MyMembershipCard",
  props: ['year', 'month', 'day', 'guid'],
  data() {
    return {
      statusText: null,
      isLoading: false,
      isGenerating: false,
      imageSrc: null,
      blob: null,
      message: null,
      isValid: false,
      idNumber: null,
    }
  },
  methods: {
    async submit() {
      this.isLoading = true;
      this.statusText = 'Validating ID Number, please wait...';
      const response = await customerService.validateIdForMembershipCard(this.year, this.month, this.day, this.guid, this.idNumber);
      let isValid = response.data.isValid;
      if (!isValid) {
        this.message = "The ID Number you've entered is not valid for this url. Please verify your details and try again."
        this.statusText = null;
        this.isLoading = false;
      } else {
        this.statusText = "Retrieving your membership card, please wait...";
        this.getCardImage();
        this.isLoading = false;
      }

    },
    getCardImage() {
      this.isLoading = true;
      axios({
        url: `${axios.defaults.baseURL}customer/membershipcard/${this.year}/${this.month}/${this.day}/${this.guid}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const contentType = response.headers['content-type'];
        const blob = new Blob([response.data], {type: contentType});
        this.blob = blob;
        this.imageSrc = URL.createObjectURL(blob);
        this.isLoading = false;
      });
    },
    downloadCard() {
      const FileSaver = require('file-saver');
      FileSaver.saveAs(this.blob, "AccisureMembershipCard.png");
    }
  },
  mounted() {
    //this.getCardImage();
  },
}
</script>

<style scoped>

</style>
